import './Share.scss';
import { forAll } from '@mindscreen/nodetypes/FrontendSrc/JavaScript/util';

/**
 * @param {MouseEvent} e
 */
const focusOnClick = e => {
    (/** @type {HTMLInputElement} */(e.target)).select();
};
const copyLink = (container) => () => {
    /** @type {HTMLInputElement} */
    const inp = container.querySelector('.js-share__copy-link__input');
    if (!inp) return;
    if (document.execCommand('copy')) {
        /** @type {HTMLDivElement} */
        const feedback = container.querySelector('.js-share__copy-link__feedback');
        if (!feedback) return;
        feedback.style.display = 'block';
    }
};

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.js-dialog-disclosure')) {
        forAll('.js-share__copy-link__button', i => {
            i.addEventListener('click', copyLink(i.parentElement.parentElement));
        });
        forAll('.js-share__copy-link__input', i => {
            i.addEventListener('click', focusOnClick);
        });
    }
});
